import React from 'react';
import {Dates, Time} from '../utils';

const fullScaleChoices = [
  Dates.DAY,
  Dates.LAST_24_HOURS,
  Dates.WEEK,
  Dates.LAST_7_DAYS,
  Dates.MONTH,
  Dates.LAST_30_DAYS,
  Dates.YEAR,
] as Time.Scale[];

const useScaleChoices = (chartView: boolean = true) => {
  const [scaleChoices, setScaleChoices] = React.useState(fullScaleChoices);

  React.useEffect(() => {
    setScaleChoices(
      !chartView
        ? fullScaleChoices.filter((s) => !Dates.LAST_SCALE_CHOICES.includes(s))
        : fullScaleChoices,
    );
  }, [chartView]);

  return scaleChoices;
};

export default useScaleChoices;
